const nf = new Intl.NumberFormat('de-CH')
import { Link } from '@ta-interaktiv/contentbricks'
import React, { useEffect, useState } from 'react'

export const num = (num: number) => (num < 10000 ? num : nf.format(num))
export const dateformat = (datestring: string) =>
  new Date(datestring).toLocaleDateString('ch-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
export const dateformatX = (datestring: string) =>
  new Date(datestring).toLocaleDateString('ch-DE', {
    month: 'short'
  })
export const parseText = (textIn: string) => {
  let bolds = textIn.match(/\##(.*?)\##/g)?.map(m => {
    let cleaned = m.split('##').join('')
    return { type: 'bold', t: cleaned, o: m.split('##').join('') }
  })
  let links = textIn.match(/\!!(.*?)\!!/g)?.map(m => {
    const splited = m
      .split('!!')
      .join('++')
      .split('++')
      .filter(f => f !== '')
    return {
      type: 'link',
      o: m.split('!!').join(''),
      t: splited[0],
      u: splited[1]
    }
  })

  let searches = (bolds || []).concat(links || [])
  let textOut: (JSX.Element | string)[] | string = textIn.split("##").join("!!").split("!!")

  textOut = textOut.map(m => {
    let hit = searches.find(f => f.o === m)
    if (hit) return replaceWithJSX(hit)
    return m
  })

  return textOut
}

const replaceWithJSX = (search: {
  type: 'link' | 'bold'
  o: string
  t: string
  u?: string
}) => {
  let ret = <></>
  switch (search.type) {
    case 'link':
      let url = search.u || ''

      ret = (
        <Link href={url} allowWordWrap>
          {search.t}
        </Link>
      )
      break
    case 'bold':
      ret = <b>{search.t}</b>
      break
  }
  return ret
}
